import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../../helpers/global_helper";
import infoIcon from "../../../../../../assets/images/Icons/info_icon.svg";
import ErrorPopup from "../../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../../Popups/ErrorInnerPopup";
import BbfsPopup from "./BbfsPopup";
import ConfirmBetDeskonPopup from "../../../../../Popups/ConfirmBetDeskonPopup";
import CancelledBetDeskonPopup from "../../../../../Popups/CancelledBetDeskonPopup";
import {
  formatPricewithdecimal,
  formatPrice,
} from "../../../../../NumberFormat";
import { withTranslation } from "react-i18next";
import { getUserBalance, setCommonConfig } from "../../../../../../redux/actions";
import GameClosedPopup from "../../../GameClosedPopup";
import MarketClose from "../../../MarketClose";

const BbfsBetDiscountVersiWap = (props) => {
  const dispatch = useDispatch();
  const { betType } = props;
  const fullBetValue = betType == 'fullbet' ? 1 : 0;
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [totalData, setTotalData] = useState({});
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [inputs, setInputs] = useState({
    namor: "",
    beli4D: "",
    depan3D: "",
    belakang3D: "",
    belakang2D: "",
    depan2D: "",
    tengah2D: "",
  });
  const [betPattern, setBetPattern] = useState({
    belakang: "",
    depan: "",
    tengah: "",
  });
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [submitPopup, setSubmitPopup] = useState(false);
  const [submitResult, setSubmitResult] = useState({});
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const [totalCountCond, setTotalCountCond] = useState(1);
  const [optionsEnabled, setOptionsEnabled] = useState({
    "2D Belakang": false,
    "2D Depan": false,
    "2D Tengah": false,
    "3D Depan": false,
    "3D Belakang": false,
    "4D Belakang": false,
    "namor" : true
  });

  const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
  const [multipleValue, setMultipleValue] = useState('');
  useEffect(() => {
    let multiple = '';
    if (game_sub_child_type === 'DISCOUNT') {
      multiple = betDiscount.showMultiple;
    } else if (game_sub_child_type === 'FULLBET') {
      multiple = betDiscount.showMultipleFullbet;
    } else {
      multiple = betDiscount.showMultiple;
    }
    setMultipleValue(multiple);
  }, [game_sub_child_type]);

  // Function to update textarea values and betPattern
  const updateBetPattern = (name, value) => {
    setBetPattern((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const closeSubmitPopup = () => {
    setSubmitPopup(false);
    handleReset();
  };

  useEffect(() => {
    handleReset();
  }, [gameId]);

  useEffect(() => {
    if (Object.keys(betDiscount).length <= 0) {
      setErrorMessage("Togel Data API missing, Refresh page and try again.");
      setShowErrorPopup(true);
      return;
    }
  }, [betDiscount]);

  useEffect(() => {
    const guessLength = inputs.namor.length;

    if (guessLength === 2) {
      setOptionsEnabled({
        "2D Belakang": true,
        "2D Depan": true,
        "2D Tengah": true,
        "3D Depan": false,
        "3D Belakang": false,
        "4D Belakang": false,
        "namor" : true

      });
    } else if (guessLength === 3) {
      setOptionsEnabled({
        "2D Belakang": true,
        "2D Depan": true,
        "2D Tengah": true,
        "3D Depan": true,
        "3D Belakang": true,
        "4D Belakang": false,
        "namor" : true
      });
    } else if (guessLength >= 4 && guessLength <= 9) {
      setOptionsEnabled({
        "2D Belakang": true,
        "2D Depan": true,
        "2D Tengah": true,
        "3D Depan": true,
        "3D Belakang": true,
        "4D Belakang": true,
        "namor" : true
      });
    } else {
      setOptionsEnabled({
        "2D Belakang": false,
        "2D Depan": false,
        "2D Tengah": false,
        "3D Depan": false,
        "3D Belakang": false,
        "4D Belakang": false,
        "namor" : true
      });
    }

    if (guessLength < 9) {
      const resetDisabledInputs = {};
      if (!optionsEnabled["4D Belakang"] || guessLength < 4) resetDisabledInputs.beli4D = "";
      if (!optionsEnabled["3D Depan"] || guessLength < 3) resetDisabledInputs.depan3D = "";
      if (!optionsEnabled["3D Belakang"] || guessLength < 3) resetDisabledInputs.belakang3D = "";
      if (!optionsEnabled["2D Belakang"] || guessLength < 2) resetDisabledInputs.belakang2D = "";
      if (!optionsEnabled["2D Depan"] || guessLength < 2) resetDisabledInputs.depan2D = "";
      if (!optionsEnabled["2D Tengah"] || guessLength < 2) resetDisabledInputs.tengah2D = "";
      setInputs((prevInputs) => ({ ...prevInputs, ...resetDisabledInputs }));
    }

  }, [inputs.namor]);

  const handleNamorOnchange = (e) => {
    const { name, value } = e.target;
    if (!/^[0-9]*$/.test(value)) {
      return;
    }
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
  };

  const handleNamorInputChange = useCallback((e) => {
    const { name, value } = e.target;
    if (value !== "") {
      if (value.length > 9 || value.length < 2 || !/^[0-9]*$/.test(value)) {
        setErrorMessage(props.t("guess_filled_24_digit"));
        setShowErrorPopup(true);
        setInputs((prevInputs) => ({ ...prevInputs, [name]: "" }));
        return;
      }
    }
    setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
  }, []);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    const displayname = e.target.getAttribute("displayname");
    const intValue = parseInt(value);

    let minValue = null;
    let maxValue = null;

    if (name == "beli4D") {
      if (betType == "discount") {
        minValue = betDiscount.showMin4d / 1000;
        maxValue = betDiscount.showMax4d / 1000;
      } else if (betType == "fullbet") {
        minValue = betDiscount.showMin4dFullbet / 1000;
        maxValue = betDiscount.showMax4dFullbet / 1000;
      } else if (betType == "prize123") {
        minValue = betDiscount.showMin4dPrize123 / 1000;
        maxValue = betDiscount.showMax4dPrize123 / 1000;
      }
    } else if (name == "belakang3D") {
      if (betType == "discount") {
        minValue = betDiscount.showMin3dBelakang / 1000;
        maxValue = betDiscount.showMax3dBelakang / 1000;
      } else if (betType == "fullbet") {
        minValue = betDiscount.showMin3dBelakangFullbet / 1000;
        maxValue = betDiscount.showMax3dBelakangFullbet / 1000;
      } else if (betType == "prize123") {
        minValue = betDiscount.showMin3dBelakangPrize123 / 1000;
        maxValue = betDiscount.showMax3dBelakangPrize123 / 1000;
      }
    } else if (name == "belakang2D") {
      if (betType == "discount") {
        minValue = betDiscount.showMin2dBelakang / 1000;
        maxValue = betDiscount.showMax2dBelakang / 1000;
      } else if (betType == "fullbet") {
        minValue = betDiscount.showMin2dBelakangFullbet / 1000;
        maxValue = betDiscount.showMax2dBelakangFullbet / 1000;
      } else if (betType == "prize123") {
        minValue = betDiscount.showMin2dBelakangPrize123 / 1000;
        maxValue = betDiscount.showMax2dBelakangPrize123 / 1000;
      }
    } else if (name == "depan3D") {
      if (betType == "discount") {
        minValue = betDiscount.showMin3dDepan / 1000;
        maxValue = betDiscount.showMax3dDepan / 1000;
      } else if (betType == "fullbet") {
        minValue = betDiscount.showMin3dDepanFullbet / 1000;
        maxValue = betDiscount.showMax3dDepanFullbet / 1000;
      } else if (betType == "prize123") {
        minValue = betDiscount.showMin3dDepanPrize123 / 1000;
        maxValue = betDiscount.showMax3dDepanPrize123 / 1000;
      }
    } else if (name == "depan2D") {
      if (betType == "discount") {
        minValue = betDiscount.showMin2dDepan / 1000;
        maxValue = betDiscount.showMax2dDepan / 1000;
      } else if (betType == "fullbet") {
        minValue = betDiscount.showMin2dDepanFullbet / 1000;
        maxValue = betDiscount.showMax2dDepanFullbet / 1000;
      } else if (betType == "prize123") {
        minValue = betDiscount.showMin2dDepanPrize123 / 1000;
        maxValue = betDiscount.showMax2dDepanPrize123 / 1000;
      }
    } else if (name == "tengah2D") {
      if (betType == "discount") {
        minValue = betDiscount.showMin2dTengah / 1000;
        maxValue = betDiscount.showMax2dTengah / 1000;
      } else if (betType == "fullbet") {
        minValue = betDiscount.showMin2dTengahFullbet / 1000;
        maxValue = betDiscount.showMax2dTengahFullbet / 1000;
      } else if (betType == "prize123") {
        minValue = betDiscount.showMin2dTengahPrize123 / 1000;
        maxValue = betDiscount.showMax2dTengahPrize123 / 1000;
      }
    }

    if (intValue < minValue) {
      setErrorMessage(`Minimal bet ${displayname} is ${minValue}`);
      setShowErrorPopup(true);
      return;
    } else if (intValue > maxValue) {
      setErrorMessage(`Your bet nominal exceeds the maximum limit.`);
      setShowErrorPopup(true);
      return;
    }

    if (value === "" || (/^[0-9]*$/.test(value) && !isNaN(intValue))) {
      setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
    }
  }, []);

  // onChange handler for all textareas
  const handleTextareaChange = (e) => {
    const { name, value } = e.target;

    // Validate the input value (only accept #, *, numbers)
    const isValid = /^[0-9*#+]*$/.test(value);

    if (!isValid) {
      return;
    }

    updateBetPattern(name, value);
  };

  const handleReset = () => {
    setInputs({
      namor: "",
      beli4D: "",
      depan3D: "",
      belakang3D: "",
      belakang2D: "",
      depan2D: "",
      tengah2D: "",
    });
    setBetPattern({
      belakang: "",
      depan: "",
      tengah: "",
    });
    setOptionsEnabled({
      "2D Belakang": false,
      "2D Depan": false,
      "2D Tengah": false,
      "3D Depan": false,
      "3D Belakang": false,
      "4D Belakang": false,
      "namor" : true
    });
    setTotalData({});
    setTotalCountClick(false);
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const totalCount = (data) => {
    // if (
    //   betPattern.belakang === "" &&
    //   betPattern.depan === "" &&
    //   betPattern.tengah === ""
    // ) {
    //   setErrorMessage(props.t("format_input"));
    //   setShowErrorPopup(true);
    //   return;
    // }
    // data = {
    //   gameId: gameId,
    //   gameType: "bbcampuran",
    //   databet_depan: betPattern.depan,
    //   databet_tengah: betPattern.tengah,
    //   databet_belakang: betPattern.belakang,
    //   dfp: betType,
    //   fastbet: true,
    //   isfullbet: fullBetValue
    // };

    // let matchValidate = matchValidateVersi("bbcampuran", data);
    // if (matchValidate) {
    //   showMessage(matchValidate, "error", "error");
    //   return;
    // }
    submitProcess(data, 1)
    // makeAjax(url.TOGEL_API.processDataBet, data).then((response) => {
    //   if (response.status !== respStatus["SUCCESS"]) {
    //     if (response.code === "sub_game_status_close") {
    //       setShowGameClose(true);
    //       showMessage(false);
    //       hideCommonToaster();
    //       dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
    //       return;
    //     }
    //     if (response.code === "market_close_err") {
    //       setShowMarketClose(true);
    //       showMessage(false);
    //       hideCommonToaster();
    //       dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
    //       return;
    //     }
    //     if (response.code !== "validation_error") {
    //       showMessage(response.code, "error", "error");
    //       setTotalData({});
    //       return;
    //     }
    //     showMessage(response.code, "error", "error");
    //     setTotalData({});
    //     return;
    //   }
    //   setTotalCountCond(1)
    //   setTotalData(response.data);
    //   setTotalCountClick(true);
    // });
  };

  const generate = (data) => {
    const {
      namor,
      beli4D,
      depan3D,
      belakang3D,
      belakang2D,
      depan2D,
      tengah2D,
    } = inputs;
    const dataangka = [];

    if (
      (beli4D.trim() === "" &&
        depan3D.trim() === "" &&
        belakang3D.trim() === "" &&
        belakang2D.trim() === "" &&
        depan2D.trim() === "" &&
        tengah2D.trim() === "") ||
      namor.trim() === ""
    ) {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
      return;
    }

    if (beli4D != 0 && beli4D != "") {
      dataangka.push(["4D-" + namor, beli4D * multipleValue, "success"]);
    }

    if (depan3D != 0 && depan3D != "") {
      dataangka.push(["3D Depan-" + namor, depan3D * multipleValue, "success"]);
    }

    if (belakang3D != 0 && belakang3D != "") {
      dataangka.push(["3D Belakang-" + namor, belakang3D * multipleValue, "success"]);
    }

    if (depan2D != 0 && depan2D != "") {
      dataangka.push(["2D Depan-" + namor, depan2D * multipleValue, "success"]);
    }

    if (tengah2D != 0 && tengah2D != "") {
      dataangka.push(["2D Tengah-" + namor, tengah2D * multipleValue, "success"]);
    }

    if (belakang2D != 0 && belakang2D != "") {
      dataangka.push(["2D Belakang-" + namor, belakang2D * multipleValue, "success"]);
    }

    data = {
      gameId: gameId,
      dataangka: dataangka,
      gameType: "bbcampuran",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dfp: betType,
      fastbet: true,
      isfullbet: fullBetValue
    };
    makeAjax(url.TOGEL_API.processBBCampuran, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          showMessage(response.code, "error", "error");
          return;
        }
        showMessage(response.code, "error", "error");
        return;
      }
      setOptionsEnabled({
        "2D Belakang": false,
        "2D Depan": false,
        "2D Tengah": false,
        "3D Depan": false,
        "3D Belakang": false,
        "4D Belakang": false,
        "namor" : false
      });
      setBetPattern(response.data);
    });
  };

  const submitProcess = (data, countCond = 0) => {
    // if (totalCountClick) {
    //   setShowConfirmationPopup(true);
    // } else {
      if (
        betPattern.belakang === "" &&
        betPattern.depan === "" &&
        betPattern.tengah === ""
      ) {
        setErrorMessage(props.t("format_input"));
        setShowErrorPopup(true);
        return;
      }
      data = {
        gameId: gameId,
        gameType: "bbcampuran",
        databet_depan: betPattern.depan,
        databet_tengah: betPattern.tengah,
        databet_belakang: betPattern.belakang,
        dfp: betType,
        fastbet: true,
        isfullbet: fullBetValue,
        multiple: multipleValue
      };

      let matchValidate = matchValidateVersi("bbcampuran", data);
      if (matchValidate) {
        showMessage(matchValidate, "error", "error");
        return;
      }

      makeAjax(url.TOGEL_API.processDataBet, data).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          if (response.code !== "validation_error") {
            showMessage(response.code, "error", "error");
            setTotalData({});
            return;
          }
          showMessage(response.code, "error", "error");
          setTotalData({});
          return;
        }
        setTotalCountCond(countCond)
        setTotalData(response.data);
        if(countCond === 0) {
          setShowConfirmationPopup(true);

        }
      });
   // }
  };

  const processBetPattern = (pattern) => {
    const dataangka = [];

    if (totalCountCond > 0) {
      if (pattern !== "" && pattern.includes("#")) {
        const parts = pattern.split("+");
        parts.forEach((part) => {
          const [numbers, modifier] = part.split("#");
          const modifierValue = parseInt(modifier.replace("#", ""), 10);

          numbers.split("*").forEach((number) => {
            let formattedNumber;
            if (number.length === 4) {
              formattedNumber = number;
            } else if (number.length === 3) {
              if (pattern === betPattern.depan) {
                formattedNumber = number + "X";
              } else {
                formattedNumber = "X" + number;
              }
            } else if (number.length === 2) {
              if (pattern === betPattern.depan) {
                formattedNumber = number + "XX";
              } else if (pattern === betPattern.belakang) {
                formattedNumber = "XX" + number;
              } else {
                formattedNumber = "X" + number + "X";
              }
            }
            dataangka.push([formattedNumber, modifierValue * multipleValue, "success"]);
          });
        });
      }
    }
    return dataangka;
  };

  const submitBBFS = (data) => {
    setShowConfirmationPopup(false);
    const dataangka = [];

    // Process belakang  // Process depan  // Process tengah
    if (totalCountCond > 0) {
      dataangka.push(...processBetPattern(betPattern.belakang));
      dataangka.push(...processBetPattern(betPattern.depan));
      dataangka.push(...processBetPattern(betPattern.tengah));
    }
    else {
      totalData.dataangka.forEach((value) => {
        dataangka.push([value.nomor, value.taruhan, "success"]);
      });
    }

    if (dataangka.length === 0) {
      setErrorMessage(props.t("format_input"));
      setShowErrorPopup(true);
      return;
    }

    data = {
      gameId: gameId,
      dataangka: dataangka,
      gameType: "bbcampuran",
      betTogelAuth: "betTogelAuth",
      allowPartner: "allowPartner",
      dfp: betType,
      fastbet: true,
      isfullbet: fullBetValue
    };
    makeAjax(url.TOGEL_API.process4D3D2D, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        setErrorMessage(props.t(response.code))
        setShowErrorPopup(true);
        return;
      }
      setSubmitResult(response.data);
      dispatch(getUserBalance());
    });
  };

  useEffect(() => {
    if (Object.keys(submitResult).length > 0) {
      setSubmitPopup(true);
    }
  }, [submitResult]);
  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };
  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="bbfs_versiwap_container">
            {device === "Desktop" ? (
              <div className="versicontainer_new">
                <table>
                  <thead>
                    <tr className="Heading">
                      <th>{props.t('number')}</th>
                      <th>4D</th>
                      <th>3D Belakang</th>
                      <th>2D Belakang</th>
                      <th>3D Depan</th>
                      <th>2D Depan</th>
                      <th>2D Tengah</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="inputs">
                        <input
                          type="text"
                          maxlength="9"
                          value={inputs.namor}
                          name="namor"
                          autoComplete="off"
                          onBlur={handleNamorInputChange}
                          onChange={handleNamorOnchange}
                          disabled={!optionsEnabled["namor"]}

                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="beli4D"
                          displayname="4D"
                          value={inputs.beli4D}
                          onChange={handleInputChange}
                          placeholder="Bet"
                          disabled={!optionsEnabled["4D Belakang"]}

                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="belakang3D"
                          displayname="3D belakang"
                          value={inputs.belakang3D}
                          onChange={handleInputChange}
                          placeholder="Bet"
                          disabled={!optionsEnabled["3D Belakang"]}

                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="belakang2D"
                          displayname="2D belakang"
                          value={inputs.belakang2D}
                          onChange={handleInputChange}
                          placeholder="Bet"
                          disabled={!optionsEnabled["2D Belakang"]}

                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="depan3D"
                          displayname="3D depan"
                          value={inputs.depan3D}
                          onChange={handleInputChange}
                          placeholder="Bet"
                          disabled={!optionsEnabled["3D Depan"]}
                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="depan2D"
                          displayname="2D depan"
                          value={inputs.depan2D}
                          onChange={handleInputChange}
                          placeholder="Bet"
                          disabled={!optionsEnabled["2D Depan"]}

                        />
                      </td>
                      <td className="inputs">
                        <input
                          type="text"
                          name="tengah2D"
                          displayname="2D tengah"
                          value={inputs.tengah2D}
                          onChange={handleInputChange}
                          placeholder="Bet"
                          disabled={!optionsEnabled["2D Tengah"]}

                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="bolak_balik_table_container">
                <div className="bb_table_item">
                {/* <th>{props.t('number')}</th> */}

                  <p>{props.t('number')}</p>
                  <input
                    type="text"
                    maxlength="9"
                    value={inputs.namor}
                    name="namor"
                    autoComplete="off"
                    onBlur={handleNamorInputChange}
                    onChange={handleNamorOnchange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    disabled={!optionsEnabled["namor"]}
                  />
                </div>
                <div className="bb_table_item">
                  <p>4D</p>
                  <input
                    type="text"
                    name="beli4D"
                    displayname="4D"
                    value={inputs.beli4D}
                    onChange={handleInputChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Bet"
                    disabled={!optionsEnabled["4D Belakang"]}

                  />
                </div>
                <div className="bb_table_item">
                  <p>3D Belakang</p>
                  <input
                    type="text"
                    name="belakang3D"
                    displayname="3D belakang"
                    value={inputs.belakang3D}
                    onChange={handleInputChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Bet"
                    disabled={!optionsEnabled["3D Belakang"]}

                  />
                </div>
                <div className="bb_table_item">
                  <p>2D Belakang </p>
                  <input
                    type="text"
                    name="belakang2D"
                    displayname="2D belakang"
                    value={inputs.belakang2D}
                    onChange={handleInputChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Bet"
                    disabled={!optionsEnabled["2D Belakang"]}

                  />
                </div>
                <div className="bb_table_item">
                  <p>3D Depan</p>
                  <input
                    type="text"
                    name="depan3D"
                    displayname="3D depan"
                    value={inputs.depan3D}
                    onChange={handleInputChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Bet"
                    disabled={!optionsEnabled["3D Depan"]}

                  />
                </div>
                <div className="bb_table_item">
                  <p>2D Depan</p>
                  <input
                    type="text"
                    name="depan2D"
                    displayname="2D depan"
                    value={inputs.depan2D}
                    onChange={handleInputChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Bet"
                    disabled={!optionsEnabled["2D Depan"]}

                  />
                </div>
                <div className="bb_table_item">
                  <p>2D Tengah</p>
                  <input
                    type="text"
                    name="tengah2D"
                    displayname="2D tengah"
                    value={inputs.tengah2D}
                    onChange={handleInputChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Bet"
                    disabled={!optionsEnabled["2D Tengah"]}
                  />
                </div>
              </div>
            )}
            <div className="btnGenerate">
              <button onClick={generate}>Generate</button>
            </div>
          </div>
          <div className="versicontainer_new">
            <p>4D, 3D dan 2D (Belakang)</p>
            <textarea
              rows="7"
              placeholder="123*1234*12#5+11*222*333#1+33*777#2"
              name="belakang"
              value={betPattern.belakang}
              onChange={handleTextareaChange}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Depan</p>
            <textarea
              rows="7"
              placeholder="123*1234*12#5+11*222*333#1+33*777#2"
              name="depan"
              value={betPattern.depan}
              onChange={handleTextareaChange}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Tengah</p>
            <textarea
              rows="7"
              placeholder="123*1234*12#5+11*222*333#1+33*777#2"
              name="tengah"
              value={betPattern.tengah}
              onChange={handleTextareaChange}
            ></textarea>
          </div>

          {/* 1 */}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {totalData.line ? totalData.line : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {totalData.tover ? formatPrice(totalData.tover) : "-"} &nbsp;
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total {props.t("discount")}</span>:{" "}
                  {totalData.disc >= 0 ? formatPrice(totalData.disc) : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {totalData.pay ? formatPrice(totalData.pay) : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">
                        {" "}
                        123*1234*12#5000+11*222*333#1000+33*777#2000
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {multipleValue}
              </p>
            </div>
          </div>
          {/* button*/}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={totalCount}>{props.t("count_total")}</button>
              </div>
              <div className="button_right">
                <button onClick={handleReset}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={submitProcess} className="submit">
                {props.t('submit')}
              </button>
            </div>
          </div>
        </>
      )}

      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }

      {submitPopup && (
        <BbfsPopup onClose={closeSubmitPopup} submitResult={submitResult} />
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitBBFS}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
    </div>
  );
};

export default withTranslation()(BbfsBetDiscountVersiWap);
